<!--
 * @Description: 火蓝机电
 * @Author: kecraft
 * @Date: 2024-08-19 10:22:01
 * @LastEditors: kecraft
 * @LastEditTime: 2024-08-23 10:05:53
 * @FilePath: /custom-website-desk/src/views/enterpriseCulture/components/frameworkNew.vue
-->
<template>
  <div class="frame-work">
    <div v-if="!showDetail" style="padding-top: 127px" id="frameworkBox">
      <div class="framework-top">
        <div class="framework-top-left">
          <img
            v-if="chooseItem1.icon"
            :src="chooseItem1.icon || defaultImg()"
            alt=""
            onerror="this.onerror=null;this.src=defaultImg()"
            class="top-right"
          />
          <div
            class="left-item"
            v-for="(item, index) of topList"
            :key="index"
            :class="chooseItem1.id === item.id ? 'is_select' : ''"
            @mouseenter="handleChoose(item)"
          >
            <div class="is-title">{{ item.title }}</div>
            <div class="is-text">{{ item.direction }}</div>
          </div>
        </div>
      </div>
      <div class="framework-bottom">
        <div class="bottom-left">
          <div
            class="bottom-left-item"
            v-for="(item, index) of tabList"
            :key="index"
            @click="changeItem(item)"
            :class="chooseItem === item.id ? 'left-select' : ''"
          >
            <div class="is-line"></div>
            <div class="is-name">{{ item.title }}</div>
          </div>
        </div>

        <div class="bottom-right">
          <div class="card-list">
            <div v-for="(item, index) of list1" class="card-item" :key="index">
              <div class="list-number">{{ dealTime(item.timeline) }}</div>
              <div class="list-time">{{ dealTime1(item.timeline) }}</div>
              <div class="list-title">{{ showTitle }}</div>
              <img
                v-if="item.thumbUrl"
                :src="item.thumbUrl || defaultImg()"
                alt=""
                onerror="this.onerror=null;this.src=defaultImg()"
                class="list-img"
              />
              <img
                v-else
                :src="require(`@/assets/type2-${index + 1}.png`)"
                class="list-img"
              />
              <div class="list-content">{{ item.title }}</div>
              <div
                class="list-btn"
                @click="
                  item.link
                    ? turnToPage(item)
                    : turnTo({
                        url: '/enterpriseCulture',
                        query: {
                          id: 1,
                          title: item.title,
                          content: item.id,
                        },
                      })
                "
              >
                查看详情<img src="@/assets/framework/arrow.png" />
              </div>
            </div>
          </div>
          <div class="bottom-list">
            <div
              class="list-item"
              v-for="(item, index) of tableList"
              :key="index"
              @click="
                item.link
                  ? turnToPage(item)
                  : turnTo({
                      url: '/enterpriseCulture',
                      query: {
                        id: 1,
                        title: item.title,
                        content: item.id,
                      },
                    })
              "
            >
              <div class="item-content">{{ item.title }}</div>
              <div class="item-time">{{ item.timeline.split(" ")[0] }}</div>
            </div>

            <div class="page_box">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="totalValue"
                @current-change="handleCurrentChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right_article2" v-else>
      <div class="small_title">
        <span @click="backFn">返回</span>
      </div>
      <div class="article_box">
        <div class="title">{{ nowChoose.title }}</div>
        <img
          v-if="nowChoose.thumbUrl"
          :src="nowChoose.thumbUrl || defaultImg()"
          alt=""
          onerror="this.onerror=null;this.src=defaultImg()"
        />
        <div class="article" v-html="normalizeRichText(nowChoose.content)"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import api from "@/api/api";
import { normalizeRichText } from "@/utils/richText";
import { ref, reactive, nextTick, onMounted, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();
let totalValue = ref(0);
const showTitle = ref("");
const list1 = ref([]);
const swiperList = ref([]);
let params = reactive({
  pageNo: 1,
  pageSize: 10,
  resourceId: 68,
  classifyId: "",
});
const chooseItem = ref("");

const chooseItem1 = ref("");
const topList = ref([]);
const getInfoList = () => {
  api.qywhListInfo({ resourceId: 106 }).then((res) => {
    if (res.code === "0" && res.res.data) {
      topList.value = res.res.data;
      if (res.res.data.length > 0) {
        chooseItem1.value = res.res.data[0];
      }
    }
  });
};

const handleChoose = (item) => {
  chooseItem1.value = item;
};
getInfoList();

const defaultImg = () => {
  return require(`@/assets/framework/bg2.png`);
};
let tabList = ref([]);
let tableList = ref([]);
let showDetail = ref(false);
const nowChoose = ref({});
onMounted(() => {
  getMenu();
  api.qywhListInfo({ resourceId: 109 }).then((res) => {
    if (res.code === "0" && res.res.data) {
      swiperList.value = res.res.data;
    }
  });
  // setWidth();
  // window.addEventListener("resize", () => {
  //   setWidth();
  // });
});

// const setWidth = () => {
//   const width = window.innerWidth;
//   if (width < 1920) {
//     const box = document.getElementById("frameworkBox");
//     const rate = width / 1920;
//     box.style.transformOrigin = "center top";
//     box.style.transform = `scaleX(${rate}) scaleY(${rate})`;
//   }
// };
const backFn = () => {
  showDetail.value = false;
  turnTo({
    url: "/enterpriseCulture",
    query: {
      id: 1,
    },
  });
};

const turnToPage = (item) => {
  window.open(item.link, "_blank");
};
const turnTo = (data) => {
  router.push({
    path: data.url,
    query: data.query,
  });
};
const handleCurrentChange = (val) => {
  params.pageNo = val;
  nextTick(() => {
    getList();
  });
};
const dealTime = (v) => {
  const time = v.split(" ")[0];
  const list = time.split("-");
  let result = list[2];
  return result;
};
const dealTime1 = (v) => {
  const time = v.split(" ")[0];
  const list = time.split("-");
  let result = list[1];
  let year = list[0];
  return result + "/" + year;
};
const changeItem = (item) => {
  chooseItem.value = item.id;
  showTitle.value = item.title;
  nextTick(() => {
    getList();
  });
};

const getMenu = async () => {
  tabList.value = [
    {
      auditFlag: 1,
      id: 6,
      orderIndex: 19,
      resourceId: 123,
      title: "工会之家",
      updatedTime: "2024-06-14 10:05",
    },
  ];
  chooseItem.value = tabList.value[0].id;
  showTitle.value = tabList.value[0].title;
  nextTick(() => {
    getList();
  });
};
const getList = async () => {
  params.classifyId = chooseItem.value;
  let res = await api.getArticlePage(params);
  if (res.code === "0") {
    totalValue.value = res.res.data.total;
    if (res.res.data.records && res.res.data.records.length > 3) {
      const list = res.res.data.records.slice(0, 3);
      list1.value = list;
      const listBottom = res.res.data.records.slice(3, totalValue.value - 1);
      tableList.value = listBottom;
    } else {
      const list = res.res.data.records;
      list1.value = list;
      tableList.value = [];
    }
  }
};

watch(
  () => route.query,
  (newValue) => {
    if (newValue && newValue.content && newValue.title) {
      api.getById({ id: newValue.content }).then((res) => {
        if (res.code === "0") {
          const newContent = res.res.data.content.replace(
            /font\-size\:(\s*\d+(?:\.\d+)?)px\s*(\;*)/gi,
            function (_styname, key, key1) {
              console.log(_styname, key, key1);
              return "font-size:" + "16px" + key1;
            }
          );
          nowChoose.value.content = newContent;
          nowChoose.value.title = newValue.title;
          showDetail.value = true;
        }
      });
    }
  },
  { immediate: true, deep: true }
);
</script>

<style lang="less" scoped>
.right_article2 {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  padding: 40px 160px;

  .small_title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: #333333;
    line-height: 20px;
    text-align: left;
    font-style: normal;

    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 20px;
      color: #999999;
      line-height: 20px;
      font-style: normal;
      cursor: pointer;
    }
  }

  .article_box {
    .title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 48px;
      color: #333333;
      line-height: 67px;
      font-style: normal;
      text-align: center;
      margin: 35px 0px 42px 0px;
    }

    img {
      width: 100%;
      height: 564px;
    }

    // .article {
    //   font-family: 仿宋_GB2312;
    //   font-weight: 600;
    //   font-size: 16px;
    //   color: #333333;
    //   line-height: 30px;
    //   text-align: left;
    //   font-style: normal;
    //   margin-top: 36px;
    //   padding-bottom: 36px;
    // }

    .detail_list {
      div {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 16px;
        color: #333;
        line-height: 30px;
        text-align: left;
        font-style: normal;
      }
    }
  }
}

.page_box {
  display: flex;
  justify-content: flex-end;
  margin-top: 60px;
  margin-bottom: 70px;
}

.frame-work {
  width: 100%;
  background: url("~@/assets/framework/bg1.png") no-repeat;
  background-size: 100% 1437px;

  .framework-top {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .framework-top-left {
    padding-right: 795px;
    position: relative;
    z-index: 100;

    .top-right {
      width: 857px;
      height: 622px;
      position: absolute;
      left: 756px;
      top: 53px;
      z-index: -1;
    }

    .left-item {
      width: 818px;
      height: 132px;
      box-sizing: border-box;
      border-radius: 0px 65px 0px 65px;
      margin-bottom: 10px;
      cursor: pointer;

      .is-title {
        padding-left: 102px;
        font-size: 40px;
        color: #333333;
        line-height: 56px;
        padding-top: 18px;
      }

      .is-text {
        font-size: 20px;
        color: #333333;
        line-height: 28px;
        padding-left: 102px;
        padding-top: 4px;
      }
    }

    .is_select {
      background: #006ab1;

      div {
        color: #ffffff !important;
      }
    }
  }

  .framework-bottom {
    margin-top: 300px;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;

    .bottom-left {
      .bottom-left-item {
        display: flex;
        align-items: center;
        margin-bottom: 42px;
        cursor: pointer;

        .is-line {
          width: 31px;
          height: 1px;
          margin-right: 47px;
        }

        .is-name {
          width: 222px;
          font-size: 24px;
          color: #333333;
          line-height: 33px;
        }
      }
    }

    .left-select {
      .is-line {
        background: #006ab1;
      }

      .is-name {
        color: #006ab1 !important;
      }
    }

    .bottom-right {
      // flex: 1;

      .card-list {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 50px;

        .card-item {
          width: 428px;
          height: 612px;
          border-left: 1px solid #d5d5d5;
          box-sizing: border-box;
          padding: 26px 42px 48px 39px;

          .list-number {
            font-weight: bold;
            font-size: 50px;
            color: #333333;
            line-height: 70px;
          }

          .list-time {
            margin-top: 6px;
            color: #333333;
            font-size: 24px;
            line-height: 33px;
          }

          .list-title {
            color: #333333;
            font-size: 36px;
            line-height: 50px;
            margin-top: 13px;
          }

          .list-img {
            width: 342px;
            height: 209px;
            margin-top: 12px;
          }

          .list-content {
            margin-top: 21px;
            height: 100px;
            font-size: 18px;
            color: #333333;
            line-height: 27px;
          }

          .list-btn {
            display: flex;
            align-items: center;
            font-size: 18px;
            color: #333333;
            line-height: 25px;
            cursor: pointer;

            img {
              width: 12px;
              height: 12px;
              margin-left: 6px;
            }
          }
        }

        .card-item:last-child {
          border-right: 1px solid #d5d5d5;
        }

        .card-item:hover {
          background: #006ab1;
          border-color: #006ab1;

          div {
            color: #ffffff !important;
          }
        }
      }

      .list-item {
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid rgba(213, 213, 213, 0.47);
        margin-bottom: 23px;

        .item-content {
          font-size: 18px;
          color: #333333;
          line-height: 25px;
        }

        .item-time {
          font-size: 18px;
          color: #9a9a9a;
          line-height: 25px;
          padding-bottom: 6px;
        }
      }
    }
  }
}
</style>
